import React from "react"
import type { SVGProps } from 'react';
import { VenueIcon, DressesIcon, PhotographerIcon, CelebrantIcon, CarIcon, HairMakeupIcon, BomboniereIcon, BridesmaidsIcon, DestinationWeddingsIcon, WeddingDressDesignersIcon, EngagementVenuesIcon, FlowerGirlDressesIcon, FormalWearIcon, HensBucksIcon, HoneymoonIcon, LingerieIcon, PhotoBoothIcon, AccessoriesIcon, AccommodationIcon, BeautyServicesIcon, CakesIcon, CaterersIcon, DecorationsIcon, FlowersIcon, HireIcon, InvitationsIcon, JewelleryIcon, MusicIcon, WeddingPlannersIcon, ServicesIcon, ShoesIcon, WeddingStylistsIcon, VideoIcon, WeddingFavoursIcon } from "@assets/icons"
import scss from "./Icons.module.scss";

// Need to replace this when removing tailwind

let categoryMap = new Map<string, any>([
      ["Bomboniere", <BomboniereIcon className={scss.icon}/>],
      ["Bridesmaids", <BridesmaidsIcon className={scss.icon}/>],
      ["DestinationWeddings", <DestinationWeddingsIcon className={scss.icon}/>],
      ["DressDesigners", <WeddingDressDesignersIcon className={scss.icon}/>],
      ["EngagementVenues", <EngagementVenuesIcon className={scss.icon}/>],
      ["FlowerGirls", <FlowerGirlDressesIcon className={scss.icon}/>],
      ["FormalWear", <FormalWearIcon className={scss.icon}/>],
      ["HensParty", <HensBucksIcon className={scss.icon}/>],
      ["Honeymoon", <HoneymoonIcon className={scss.icon}/>],
      ["Lingerie", <LingerieIcon className={scss.icon}/>],
      ["MarriageCelebrant", <CelebrantIcon className={scss.icon}/>],
      ["PhotoBooth", <PhotoBoothIcon className={scss.icon}/>],
      ["WeddingAccessories", <AccessoriesIcon className={scss.icon}/>],
      ["WeddingAccommodation", <AccommodationIcon className={scss.icon}/>],
      ["WeddingBeautyServices", <BeautyServicesIcon className={scss.icon}/>],
      ["WeddingCakes", <CakesIcon className={scss.icon}/>],
      ["WeddingCars", <CarIcon className={scss.icon}/>],
      ["WeddingCaterers", <CaterersIcon className={scss.icon}/>],
      ["WeddingDecorations", <DecorationsIcon className={scss.icon}/>],
      ["WeddingDress", <DressesIcon className={scss.icon}/>],
      ["WeddingFlowers", <FlowersIcon className={scss.icon}/>],
      ["WeddingHair", <HairMakeupIcon className={scss.icon}/>],
      ["WeddingHire", <HireIcon className={scss.icon}/>],
      ["WeddingInvitations", <InvitationsIcon className={scss.icon}/>],
      ["WeddingJewellery", <JewelleryIcon className={scss.icon}/>],
      ["WeddingMusic", <MusicIcon className={scss.icon}/>],
      ["WeddingPhotography", <PhotographerIcon className={scss.icon}/>],
      ["WeddingPlanner", <WeddingPlannersIcon className={scss.icon}/>],
      ["WeddingServices", <ServicesIcon className={scss.icon}/>],
      ["WeddingShoes", <ShoesIcon className={scss.icon}/>],
      ["WeddingStylists", <WeddingStylistsIcon className={scss.icon}/>],
      ["WeddingVenues", <VenueIcon className={scss.icon}/>],
      ["WeddingVideo", <VideoIcon className={scss.icon}/>],
      ["WeddingFavours", <WeddingFavoursIcon className={scss.icon}/>]
])

const getCategoryIcon = (name: CategoryIconName): React.FunctionComponent => {
      switch(name) {
            case "Bomboniere": return BomboniereIcon;
            case "Bridesmaids": return BridesmaidsIcon;
            case "DestinationWeddings": return DestinationWeddingsIcon;
            case "DressDesigners": return WeddingDressDesignersIcon;
            case "EngagementVenues": return EngagementVenuesIcon;
            case "FlowerGirls": return FlowerGirlDressesIcon;
            case "FormalWear": return FormalWearIcon;
            case "HensParty": return HensBucksIcon;
            case "Honeymoon": return HoneymoonIcon;
            case "Lingerie": return LingerieIcon;
            case "MarriageCelebrant": return CelebrantIcon;
            case "PhotoBooth": return PhotoBoothIcon;
            case "WeddingAccessories": return AccessoriesIcon;
            case "WeddingAccommodation": return AccommodationIcon;
            case "WeddingBeautyServices": return BeautyServicesIcon;
            case "WeddingCakes": return CakesIcon;
            case "WeddingCars": return CarIcon;
            case "WeddingCaterers": return CaterersIcon;
            case "WeddingDecorations": return DecorationsIcon;
            case "WeddingDress": return DressesIcon;
            case "WeddingFlowers": return FlowersIcon;
            case "WeddingHair": return HairMakeupIcon;
            case "WeddingHire": return HireIcon;
            case "WeddingInvitations": return InvitationsIcon;
            case "WeddingJewellery": return JewelleryIcon;
            case "WeddingMusic": return MusicIcon;
            case "WeddingPhotography": return PhotographerIcon;
            case "WeddingPlanner": return WeddingPlannersIcon;
            case "WeddingServices": return ServicesIcon;
            case "WeddingShoes": return ShoesIcon;
            case "WeddingStylists": return WeddingStylistsIcon;
            case "WeddingVenues": return VenueIcon;
            case "WeddingVideo": return VideoIcon;
            case "WeddingFavours": return WeddingFavoursIcon;
            default: return React.Fragment;
      }
}

export type CategoryIconName = "Bomboniere" |
"Bridesmaids" |
"DestinationWeddings" |
"DressDesigners" |
"EngagementVenues" |
"FlowerGirls" |
"FormalWear" |
"HensParty" |
"Honeymoon" |
"Lingerie" |
"MarriageCelebrant" |
"PhotoBooth" |
"WeddingAccessories" |
"WeddingAccommodation" |
"WeddingBeautyServices" |
"WeddingCakes" |
"WeddingCars" |
"WeddingCaterers" |
"WeddingDecorations" |
"WeddingDress" |
"WeddingFlowers" |
"WeddingHair" |
"WeddingHire" |
"WeddingInvitations" |
"WeddingJewellery" |
"WeddingMusic" |
"WeddingPhotography" |
"WeddingPlanner" |
"WeddingServices" |
"WeddingShoes" |
"WeddingStylists" |
"WeddingVenues" |
"WeddingVideo" |
"WeddingFavours";


type Props = SVGProps<HTMLOrSVGElement> & {
      name: CategoryIconName;
      defaultIcon?: CategoryIconName | false;
}

export const CategoryIcon = ({ name, defaultIcon = false, ...props }: Props) => {
      let Icon = getCategoryIcon(name);
      if (!Icon && defaultIcon) {
            Icon = getCategoryIcon(defaultIcon);
      }
      if(typeof Icon === 'function') {
            return <Icon {...props} />;
      }
      return null
}

export default categoryMap;









